import { useToken } from "@/app/services/context/TokenContext";
import { DATA_GIF_PATH, ICON_BASE_PATH } from "@/app/utils/config";
import { redirectToGrowXLogout } from "@/app/utils/loginservice/redirectToGrowXLogout";
import { useNavigate } from "react-router-dom";

export default function RegisteredSuccessfully() {
  const navigate = useNavigate();
  const { logout } = useToken();
  const handledashboard = () => navigate("/dashboard");

  // ..................................handleLogout.......................................
  const handleLogout = () => {
    setTimeout(redirectToGrowXLogout, 0);
    logout();
  };

  // ........................................UI........................................
  return (
    <div className="gx-login-card">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <div className="gx-login-success-img">
            <img src={`${DATA_GIF_PATH}done_animation.gif`} alt="Success" />
          </div>
        </div>
        <div className="col-span-12">
          <div className="gx-login-success-title">
            <h2 className="gx-h2-l">
              Your Company{" "}
              <span className="gx-h2-b"> Registered Successfully!</span>
            </h2>
            <p className="gx-p12-m">
              Your company has been created successfully. Now you can access the
              GrowX Application and onboard users from your company.
            </p>
          </div>
        </div>
        <div className="col-span-12">
          <div className="login-continue-btn">
            <button className="gx-h4-eb" onClick={handledashboard}>
              Continue to Dashboard
            </button>
          </div>
        </div>
        <div className="col-span-12">
          <div className="gx-connectbank-logout">
            <button onClick={handleLogout}>
              <img src={`${ICON_BASE_PATH}logouticon.svg`} alt="name" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
